import React, { useContext } from 'react'
import { Navbar, Container, Nav } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  HOME_PATH,
  POIS_PATH,
  EVENTS_PATH,
  MANAGE_CONTACTS_PATH,
  SHOP_PATH,
} from '../config/routes'
import { AuthContext } from '../contexts/AuthContext'

const NavigationBar = () => {
  const { t } = useTranslation()
  const { isAdmin } = useContext(AuthContext)
  const isShopEnabled = process.env.REACT_APP_TOGGLE_SHOP === 'true'

  return (
    <Navbar expand="sm" className="navbar mb-3">
      <Container>
        <Navbar.Brand as={NavLink} to={HOME_PATH}>
          <img
            src="/images/logos/logo_black_256.png"
            alt="Logo"
            style={{ height: '80px' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar-nav" />

        <Navbar.Collapse id="main-navbar-nav">
          <Nav>
            <Nav.Link as={NavLink} to={HOME_PATH} end>
              {t('HOME')}
            </Nav.Link>
            <Nav.Link as={NavLink} to={POIS_PATH}>
              {t('POINTS_OF_INTEREST')}
            </Nav.Link>
            <Nav.Link as={NavLink} to={EVENTS_PATH}>
              {t('EVENTS')}
            </Nav.Link>

            {isAdmin && (
              <Nav.Link as={NavLink} to={MANAGE_CONTACTS_PATH}>
                {t('MANAGE_TITLE')}
              </Nav.Link>
            )}

            {isShopEnabled && (
              <Nav.Link as={NavLink} to={SHOP_PATH}>
                {t('SHOP')}
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default NavigationBar
